import React from 'react';
import Icon from '../../../components/AppIcon';

const TableOfContents = ({ sections, onSectionClick }) => {
  return (
    <div className="bg-surface border border-border rounded-lg p-6 liquid-shadow sticky top-24">
      <h3 className="text-lg font-poppins font-bold text-primary mb-4 flex items-center">
        <Icon name="List" size={20} className="mr-2 text-accent" />
        Table of Contents
      </h3>
      <nav className="space-y-2">
        {sections?.map((section, index) => (
          <button
            key={section?.id}
            onClick={() => onSectionClick(section?.id)}
            className="w-full text-left px-3 py-2 rounded-md hover:bg-muted brand-transition text-text-primary hover:text-primary text-sm flex items-center"
          >
            <span className="w-6 h-6 bg-primary/10 text-primary rounded-full flex items-center justify-center text-xs font-medium mr-3">
              {index + 1}
            </span>
            {section?.title}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default TableOfContents;